/* eslint-disable eqeqeq */
import React from 'react';
import PropTypes from 'prop-types';
import ConfigurableRangeFilter from './ConfigurableRangeFilter';
import { createPrizeMoneyConfig } from './rangeConfigs';

const PrizeMoneyRangeFilter = ({ filters, searchTypes, handlePrizeMoneyChange }) => {
    const { prizeMoneyValues } = searchTypes;
    // Min/max values are 1-based indices into the prizeMoneyValues array
    const { prizeMoneyMin = 1, prizeMoneyMax = prizeMoneyValues.length } = filters;
    const prizeMoneyConfig = createPrizeMoneyConfig(prizeMoneyValues, 'range-label');

    return (
        <ConfigurableRangeFilter
            title="Prize Money"
            min={prizeMoneyMin}
            max={prizeMoneyMax}
            onChange={handlePrizeMoneyChange}
            config={prizeMoneyConfig}
        />
    );
};

PrizeMoneyRangeFilter.propTypes = {
    filters: PropTypes.instanceOf(Object).isRequired,
    searchTypes: PropTypes.instanceOf(Object).isRequired,
    handlePrizeMoneyChange: PropTypes.func.isRequired,
};

export default PrizeMoneyRangeFilter;
